import React, {useRef, useEffect, useState} from "react";
import {
    deleteFile,
    searchEmptyContentFile,
    searchFileByKey,
    searchFileContentByFileId
} from "../../../graph-services/GraphServices";
import Table2 from "../../UI/Table/MUITable";
import CvDetails from "../CvDetails/CvDetails";
import Aux from "../../../hoc/Auxiliary/Auxiliary";
import SearchData from "../SearchData/SearchData";
import Drawer from "@material-ui/core/Drawer";
import BTN from "../../UI/Button/Button";
import Grid from "@material-ui/core/Grid";
import classes from "./CVs.module.css";
import "../CvDetails/CvDetails.css";
import { ReferenceCPStatus as status } from "../ReferenceCPStatus"
import moment from "moment";
import { getLanguageFromFileName } from "../utils";

const formatDate = "YYYY-MM-DD HH:mm";
const ListCv = (props) => {
    let [count, setCount] = useState(0);
    let searchKeys = useRef("");
    const [files, setFiles] = useState([]);
    const [dataTable, setDataTable] = useState({});
    const [contentFile, setContentFile] = useState("");
    const [selectedFileId, setSelectedFileId] = useState("");
    const [selectedFileName, setSelectedFileName] = useState("");
    const [stateDrawer, setStateDrawer] = useState({ right: false, });
    let [askToCreateCommercialCV, setAskToCreateCommercialCV] = useState(false);
    let [isDataLoaded, setIsDataLoaded] = useState(false);
    const [rowsPerPage, setRowsPerPage] = React.useState(25);
    const [page, setPage] = React.useState(0);

    let handleLoading = (v) => {
        props.onLoading(v);
    }

    let checkSession = (v) => {
        props.checkSession(v);
    }

    let handleSearch = async (v) => {
        handleLoading(true)
        searchKeys.current = (v);
        await reloadData(v);
        handleLoading(false)
    }

    let checkFileStatus = (fileStatus) => {
        let colorBadge = [classes.circle];
        Object.values(status).map(e => {
            if (fileStatus === e.location) {
                colorBadge.push(e.style);
            }
            return colorBadge
        })
        return colorBadge
    }

    useEffect(() => {
        let columns = [
            {
                label: "File Name",
                id: "name",
                field: "modifiedName",
                sort: "asc",
                visibility: true,
                width: "400px"

            },
            {
                label: "Creation Date",
                field: "creationDate",
                id: "creationDate",
                sort: "asc",
                visibility: true,
                width: "auto"
            },
            {
                label: "Modification Date",
                field: "modificationDate",
                id: "modificationDate",
                sort: "asc",
                visibility: true,
                width: "auto"
            },
            {
                label: "Last Modification User ",
                field: "modificationUser",
                id: "modificationUser",
                sort: "asc",
                visibility: true,
                width: "auto"
            }
        ];
        let data = {
            columns: columns,
            rows: files,
        };
        setDataTable(data);
    }, [files, dataTable["rows"]]);

 //reload cvs if search key change
 let reloadData = async (searchKey = searchKeys.current) => {
    let data = []
    let isConsultant = !props.isAdminMember && !props.isSalesMember && !props.isHrMember

    return searchFileByKey(props.access_token, props.siteId, props.listId, props.webUrl, searchKey, "Reference", isConsultant)
        .then(r => {
            if (r.error !== undefined && r.error === 'InvalidAuthenticationToken') {
                checkSession(true)
            } else {
                r.map((el) => {
                    el.clickEvent = toggleDrawer(true, el);
                    let colorBadge = checkFileStatus(el.parentReferenceName)
                    el.modifiedName =
                        <Aux>
                            <Grid container>
                                <Grid className={classes.elementAttachedToBadge}>
                                    <div className={colorBadge.join(' ')} />
                                </Grid>
                                <Grid> {el.name.replace(".xml", "")} </Grid>
                            </Grid>
                        </Aux>
                    el.creationDate = moment(el.creationDate).format(formatDate)
                    el.modificationDate = moment(el.modificationDate).format(formatDate)
                    data.push(el)
                    return data
                })
                setFiles(data);
                setIsDataLoaded(true)
                props.setIsReferenceCPsLoaded(true)
            }
        })
}

    useEffect(() => {
        setTimeout(() => {
            setCount(count + 1);
        }, process.env.REACT_APP_RELOAD_DELAY);

    });

    useEffect(async () => {
        if (props.webUrl && props.webUrl !== "") {
            handleLoading(true)
            await reloadData(searchKeys.current)
            handleLoading(false)
        }
    }, []);

    useEffect(() => {
        if (props.listId && props.listId !== "" && props.webUrl && props.webUrl !== "") {
            reloadData(searchKeys.current)
        }
    }, [props.webUrl, count]);

    let deleteCP = fileId => {
        if (fileId) {
            handleLoading(true)
            deleteFile(props.access_token, props.siteId, fileId)
                .then(r => {
                    if (r.ok) {
                        props.notify("The Consultant Profile has been deleted !", "success")
                        setFiles(v => v.filter(el => el.id !== fileId))
                        reloadData(searchKeys.current)
                    } else {
                        props.notify("An error has occurred !", "error")
                    }
                    handleLoading(false)
                })
        } else {
            props.notify("An error has occurred !", "error")
            handleLoading(false)
        }
    }

    const isNewCommercialBtnVisible = (row) => {
        return status.validated.location === row.parentReferenceName
    }

    const toggleDrawer = (open, file, column) => async () => {
        if (column && column.label === "") {
            askToCreateCommercialCV = true
            setAskToCreateCommercialCV(true)
        } else {
            askToCreateCommercialCV = false
            setAskToCreateCommercialCV(false)
        }
        let fileId;
        let fileName;
        if (file) {
            fileId = file.id;
            fileName = file.name;
        }
        let content = null;
        if (open) {
            setSelectedFileId(fileId);
            setSelectedFileName(fileName);
            handleLoading(true);
            if (fileId) {
                content = await searchFileContentByFileId(props.access_token, props.siteId, fileId);
                props.changeLanguage(getLanguageFromFileName(fileName))
            } else {
                content = await searchEmptyContentFile();
            }

            if (content) {
                if (askToCreateCommercialCV) {
                    content.SkillsPassport.LearnerInfo["opportunity"] = {
                        name: "",
                        id: "",
                        client: Object,
                    }
                }
                await setContentFile(content);
            }
            handleLoading(false);
        }
        setStateDrawer({ right: open });
    };
    let closeDrawer = () => {
        setSelectedFileId('');
        setSelectedFileName('');
        setStateDrawer({ right: false });
        setAskToCreateCommercialCV(false)
    }

    //ADD NEW CV button
    let isAddNewBtnVisible = () => {
        return props.isHrMember || props.isAdminMember;
    }
    const addNewCV = async () => {
        props.changeLanguage(props.defaultLanguage.code)
        handleLoading(true);
        let content = await searchEmptyContentFile();
        if (content) {
            await setContentFile(content);
        }
        handleLoading(false);
        setStateDrawer({ right: true });
    };

    let checkIfExist = (fileName) => {
        return !dataTable.rows.every(el => el.name !== fileName)
    }

    let searchArea = <div className={classes.searchArea}>
        <SearchData
            pushedClass="search"
            search={handleSearch}
            isDisabled={!isDataLoaded}
            searchkeys={searchKeys.current}
            tooltipTitle = "Search Reference Consultant Profile"
        />
    </div>

    let dataArea = isDataLoaded && <div className={classes.dataArea}>
        <Table2 data={dataTable} rechargeData={isDataLoaded}
            clickRow={(row, column) => toggleDrawer(true, row, column)}
            deleteCP={deleteCP}
            isAdminMember={props.isAdminMember}
            isSalesMember={props.isSalesMember}
            isNewCommercialBtnVisible={(row) => isNewCommercialBtnVisible(row)}
            setRowsPerPage={setRowsPerPage}
            rowsPerPage={rowsPerPage}
            setPage={setPage}
            page={page}
        />
        <Grid container spacing={2} className={classes.AddMarginBottom}>
            {Object.values(status).map(e => (
                <Grid key={e.code} item>
                    <Grid container>
                        <Grid className={classes.elementAttachedToBadge}>
                            <div className={`${classes.circle} ${e.style}`} />
                        </Grid>
                        <Grid>
                            {e.label}
                        </Grid>
                    </Grid>
                </Grid>
            ))}
        </Grid>
    </div>

    let fileDrawer = <Drawer
        classes={{
            paper: classes.drawerPaper,
        }}
        anchor="right"
        open={stateDrawer["right"]}
        onClose={(_, reason) => {
            if (reason !== "backdropClick") {
                closeDrawer();
            }
        }
        }
    >
        <CvDetails
            dict={props.dict}
            addToDictionary={props.addToDictionary}
            lang={props.lang}
            defaultLanguage={props.defaultLanguage}
            changeLanguage={(language) => props.changeLanguage(language)}
            contentFile={contentFile}
            fileId={selectedFileId}
            fileName={selectedFileName}
            token={props.access_token}
            siteId={props.siteId}
            siteName={props.siteName}
            driveId={props.driveId}
            webUrl={props.webUrl}
            onLoading={(v) => handleLoading(v)}
            closeDrawer={() => closeDrawer()}
            isHrMember={props.isHrMember}
            isAdminMember={props.isAdminMember}
            isSalesMember={props.isSalesMember}
            opportunities={props.opportunities}
            isToBeCloned={askToCreateCommercialCV}
            isCommercialCP={askToCreateCommercialCV}
            userEmail={props.userEmail}
            allUsers={props.allUsers}
            notify={props.notify}
            reloadReference={reloadData}
            reloadCommercial={props.reloadCommercial}
            checkIfExist={checkIfExist}
            commercialData={props.commercialData}
        />
    </Drawer>

    let addNewCPBtn = isAddNewBtnVisible() && <Grid container spacing={3}>
        <Grid item xs={3}>
            <BTN
                label="ADD NEW CONSULTANT PROFILE"
                variant="success"
                isVisible={true}
                size="sm"
                actionHandler={() => addNewCV()}
                tooltip={`New Reference Consultant Profile`}
                style={{ width: "auto" }}
            />
        </Grid>
    </Grid>

    let infoArea = <div className={classes.infoBar}> Loading data ... </div>

    return isDataLoaded ?
        <Aux>
            {searchArea}
            {dataTable.rows.length > 0 && dataArea}
            {addNewCPBtn}
            {fileDrawer}
        </Aux> : infoArea
};

export default ListCv;
